// extracted by mini-css-extract-plugin
export default {"container":"QuickSearch_container__tO6Wr","controls":"QuickSearch_controls__U1ICB","title":"QuickSearch_title__jpiuE","actions":"QuickSearch_actions__2UVLo"};